import { useLocalSearchParams } from 'expo-router'
import { CreateFeedbackRequestFlow } from '~/components/feedback/CreateFeedbackRequestFlow'
import ScreenView from '~/components/layout/ScreenView'

export default function FeedbackAddIndex() {
  const { contactId: initialContactId } = useLocalSearchParams<{
    contactId?: string
  }>()

  return (
    <ScreenView>
      <CreateFeedbackRequestFlow
        key={initialContactId}
        initialContactId={initialContactId}
      />
    </ScreenView>
  )
}
